
import { useNavigate } from "react-router-dom"
import { useParams } from 'react-router-dom';

import { useDispatch } from "react-redux";
import { visualizerActions } from '../../store';

import { loadShareLink } from "../../Helpers/ShareHelper";

export default function LoadingPage(){

    const urlParams = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    loadShareLink(urlParams.code).then(data => {
        const shareData = JSON.parse(data.data1);
        dispatch(visualizerActions.setActiveFloorplanData(shareData.floorPlan));
        dispatch(visualizerActions.setActiveFloorplanStepsFromData(shareData.planSteps));

        navigate(`/visualizer/floorplan/${shareData.floorPlan["id"]}/area/exterior/spec/${encodeURIComponent(shareData.floorPlan["exterior"])}/sel/${shareData.floorPlan["exteriorSel"]}`)
    })

    return (
    <section>
        Loading Project...
    </section>);
}